import {Component} from "@angular/core";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {ProjectService} from "./project.service";
import {RouteHelper, RouteMapping} from "../misc/route-helper";
import {ProjectDetailModel, projectDetailModelListFactory} from "./project-detail.model";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {AppSettingsService} from "../app-settings/app-settings.service";
import {handleErrors} from "../misc/handle-errors.decorator";
import {TARGET_SYSTEM, DAAS_TARGET_SYSTEMS} from "../helpers/app-constants";
import { PrivilegeViewService } from "../privilege-view/privilege-view.service";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

@Component({
  templateUrl: "./project-assign-list.template.pug",
  providers: [
    ProjectService,
    DialogService,
  ],
})

export class ProjectAssignListComponent extends RouteHelper {
  public projects: ProjectDetailModel[] = projectDetailModelListFactory();
  public currentPage: number = DEFAULT_PAGE;
  public pageSize: number = DEFAULT_PAGE_LIMIT;
  public maxPages: number;
  public totalCount: number = 0;
  public searchText: string = "";
  public closedProjects: boolean = false;
  public includeMpcProjects: boolean = false;
  public onlyMpcProjects: boolean = false;
  public sortBy: boolean = false;
  public type: string = "";
  public searchHelp: any[] = [
    {property: "Project Name", examples: ["Globex", "\"Massive Dynamic\"", "name:Globex"]},
    // {property: "Project Country Name/ID", examples: ["US", "country:US", "country:\"United States\""]},
    // {property: "Project Geo Region", examples: ["EMEA", "region:APJ"]},
    // {property: "Project ID", examples: ["id:12345678-1234-1234-1234-123456789123"]},
    {property: "Opportunity ID", examples: ["OPP-0000580547", "opportunityId:OPP-0000580547"]},
  ];

  private targetSystemList = TARGET_SYSTEM;
  public daasTargetSytemList = DAAS_TARGET_SYSTEMS;

  public error: Error;

  public paramsMap: RouteMapping[] = [
    {fieldName: "currentPage", paramName: "page", defaultValue: DEFAULT_PAGE, type: "number"} as RouteMapping,
    {fieldName: "pageSize", paramName: "limit", defaultValue: DEFAULT_PAGE_LIMIT, type: "number"} as RouteMapping,
    {fieldName: "searchText", paramName: "search"} as RouteMapping,
    {fieldName: "closedProjects", paramName: "closed"} as RouteMapping,
    {fieldName: "includeMpcProjects", paramName: "includeMpc"} as RouteMapping,
    {fieldName: "onlyMpcProjects", paramName: "onlyMpc"} as RouteMapping,
  ];

  domain: string;
  public loading: boolean = false;
  isPurgeMasterRole: boolean = false;
  userRole: any;
  constructor(
    private projectService: ProjectService,
    public route: ActivatedRoute,
    public router: Router,
    public dialogService: DialogService,
    public appSettingsService: AppSettingsService,
    private privilegeViewService: PrivilegeViewService,
  ) {
    super();
  }

  async ngOnInit() {
    super.ngOnInit();
    this.addGlobalOpportunityToSearchHelp();
    this.appSettingsService.refreshBrowserContent.subscribe((value) => {
      const isComponentOpen = document.location.href.indexOf("/projects-assign?") > -1 || document.location.href.endsWith("/projects-assign");
      if (isComponentOpen && value === true) {
        this.refreshBrowser();
      }
      // this.appSettingsService.refreshBrowser(null);
    });
  }

  public navigate(queryParams: Params, skipLocationChange: boolean = false): Promise<boolean> {
    return this.router.navigate(["projects-assign"], {queryParams, skipLocationChange});
  }

  public async loadData() {
    this.error = undefined;
    var type = "updatedAt";

    this.domain = this.privilegeViewService.getDomainView();
    if (this.searchText) {
      this.loading = true;
      this.projectService.getProjects(
        `${this.currentPage - 1}`,
        `${this.pageSize}`,
        this.searchText,
        true,
        this.closedProjects,
        this.includeMpcProjects,
        this.onlyMpcProjects,
        true,
        "",
        true,
        type,
        this.domain,
      )
        .then(
          ({ rows, count }) => {
            this.projects = rows;
            this.projects.forEach((p) => {
              p["isCurrentUserOnProject"] = p.users.findIndex(u => !!u.isCurrentUser) >= 0;
            });
            this.maxPages = Math.ceil(count / (+this.pageSize));
            this.totalCount = count;
            this.loading = false;
          },
          (error) => {
            if (error.message === "invalid-echo") return;
            console.error(error);
            this.error = error;
            this.loading = false;
          },
        );

        this.userRole = this.appSettingsService.user.subscribe((user) => {
          if (user && user.roles && user.roles.length > 0) {
            user.roles.forEach((role) => {
              if (role.name == "Purge Master" && this.isPurgeMasterRole == false) {
                this.isPurgeMasterRole = true;
              } 
            });  
          }
        });
    }
  }

  private addGlobalOpportunityToSearchHelp() {
      // this.searchHelp.push(
      //   {property: "Global Opportunity ID", examples: ["OPD-0000574596", "globalOpportunityId:OPD-0000574596"]},
      // );
  }

  public onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }
    this.syncRoute();
  }

  public refreshBrowser() {
    this.syncRoute();
  }

  @handleErrors()
  public async assignMeToProject(projectId) {
    const res =
      await this.projectService.assignUserToProject(projectId).toPromise();
    if (res && res.success) this.loadData();
  }

  @handleErrors()
  public async unassignMeToProject(projectId) {
    const res =
      await this.projectService.unAssignUserToProject(projectId).toPromise();
    if (res && res.success) this.loadData();
  }

  async showAddSortButton(type: string) {
    if(type=="createdAt") this.type="Created Date"
    else if (type=="updatedAt") this.type="Updated Date"
    else if (type=="name") this.type="Project Name"

    this.projectService.getProjects(
      `${this.currentPage - 1}`,
      `${this.pageSize}`,
      this.searchText,
      false,
      this.closedProjects,
      this.includeMpcProjects,
      this.onlyMpcProjects,
      false,
      "",
      this.sortBy,
      type,
      this.domain,
    )
      .then(
        ({rows, count}) => {
          this.projects = rows;
          this.projects.forEach((p) => {
            p["isCurrentUserOnProject"] = p.users.findIndex(u => !!u.isCurrentUser) >= 0;
          });
          this.maxPages = Math.ceil(count / (+this.pageSize));
          this.totalCount = count;
        },
        (error) => {
          if (error.message === "invalid-echo") return;
          console.error(error);
          this.error = error;
        },
      );
  }
}
